<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpWidgetCard>
    <ItpBox
      alignItems="center"
      slot="header"
    >
      <strong>
        {{ 'General'|pgettext('Project') }}
      </strong>
      <ItpButton
        :text="'Edit...'|gettext"
        variant="light"
        size="sm"
        class="ml-auto"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
    <BListGroup
      flush
    >
      <ItpLabeledListGroupItem
        :label="'Code'|pgettext('Project')"
        :content="project.code"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Name'|pgettext('Project')"
        :content="project.name"
      >
      </ItpLabeledListGroupItem>
    </BListGroup>
  </ItpWidgetCard>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcProjectGeneral extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  project!: object;

  @Watch('project')
  onProject(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("project")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_emit_7860_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8320016629450276_emit_7860, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_8320016629450276_close_7859_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8320016629450276_close_7859, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_8320016629450276_showModal_7858_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_7858, alias=undefined
    return {
      name: "ProjectEditor",
      props: {
        target: "general",
        project: _.cloneDeep(this.project),
      }
      ,
    }
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_7856: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_7855: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_8320016629450276_emit_7860: actions.EmitAction;
    evh_8320016629450276_close_7859: actions.EventHandlerImpl;
    act_8320016629450276_showModal_7858: actions.ShowModalAction;
    evh_8320016629450276_clickPreventStop_7857: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_7856 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_7855 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_7856,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_7855],
      }
    );
    const act_8320016629450276_emit_7860 = new actions.EmitAction(
      {
        actionArgs: this.act_8320016629450276_emit_7860_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_close_7859 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_emit_7860,
        event: "close",
        when: this.evh_8320016629450276_close_7859_getWhen,
        displayName: "emit",
      }
    );
    const act_8320016629450276_showModal_7858 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_7858_getActionArgs,
        events: [evh_8320016629450276_close_7859],
      }
    );
    const evh_8320016629450276_clickPreventStop_7857 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_7858,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_7857],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_7856,
      evh_7315092382398562_reload_7855,
      evh_7315092382398562_reload,
      act_8320016629450276_emit_7860,
      evh_8320016629450276_close_7859,
      act_8320016629450276_showModal_7858,
      evh_8320016629450276_clickPreventStop_7857,
      evh_8320016629450276_clickPreventStop,
    }
  }
}

Vue.component("UcProjectGeneral", UcProjectGeneral);

</script>